<template lang="pug">
.bindOrders
  .planlist
    el-row(style='margin-bottom:1rem')
        el-col(:span='10')
            el-card
                div(slot="header")
                    span 签约支付情况统计
                    el-button.el-icon-refresh(style="float: right; padding: 6px 0;font-size: 1rem;" type="text", size="normal", @click="getKQStatics")
                el-row
                    el-col(:span='4', style='text-align:left')
                        el-statistic(:value="staticsData.normal.count" title="签约中")
                    el-col(:span='4', style='text-align:left')
                        el-statistic(:value="staticsData.bind_paid_normal.count" title="未退订且可支付")
                    el-col(:span='4', style='text-align:left')
                        el-statistic(:value="staticsData.stop.count" title="已解约")
                    el-col(:span='4', style='text-align:left')
                        el-statistic(:value="staticsData.bind_paid.count" title="有支付记录的签约")
                    el-col(:span='4', style='text-align:left')
                        el-statistic(:value="staticsData.trade_success.count" title="支付成功")
                    el-col(:span='4', style='text-align:left')
                        el-statistic(:value="staticsData.trade_refund.count" title="已退款")
    el-row(style='margin-bottom:1rem')
        el-col(:span='24' style='text-align:left')
            el-input(style='width:200px;' v-model='paginationInfo.condition.search_key' placeholder='请输入手机号/商户单号' clearable)
            el-input(style='width:200px;' v-model='paginationInfo.condition.phone_no' placeholder='请输入银行绑定的手机号' clearable)
            el-date-picker(v-model="create_date[0]", align="right", type="date", placeholder="选择开始时间",
                :picker-options="{disabledDate(time) {return time.getTime() > Date.now();}}")
            el-date-picker(v-model="create_date[1]", align="right", type="date", placeholder="选择结束时间",
                :picker-options="{disabledDate(time) {return time.getTime() > Date.now();}}")
            el-select(v-model='paginationInfo.condition.channel_code' placeholder='请选择渠道' @change='queryList(1)' filterable clearable)
                el-option(label='全部渠道' value)
                el-option(v-for='item in dictData' :key='item.dictdata_value' :label='item.dictdata_name' :value='item.dictdata_value')
            el-select(v-model='paginationInfo.condition.bind_status' placeholder='请选择签约状态' @change='queryList(1)' filterable clearable)
                el-option(label='全部' value)
                el-option(v-for='item in statusList' :key='item.value' :label='item.label' :value='item.value')
            el-button(@click='queryList(1)') 查询
    el-table(:data='tableData', style='width: 100%')
      el-table-column(type='expand')
        template(slot-scope='props')
          el-form
            el-form-item(label='IP:')
              span {{ props.row.ip }}
            el-form-item(label='user_agent:')
              span {{ props.row.http_user_agent }}
      el-table-column(prop='external_ref_number', label='签约订单号', align='center', width='150')
      el-table-column(prop='mobile', label='手机号', align='center', width='150')
      el-table-column(prop='phone_no', label='银行卡绑定手机号', align='center', width='150')
      el-table-column(label='创建时间', align='center', width='300')
        template(slot-scope='scope') {{ $moment(scope.row.create_date).format('YYYY-MM-DD HH:mm:ss')}}
      el-table-column(prop='member_type', label='会员业务编码', align='center')
      el-table-column(prop='period_rule_params.execute_time', label='首次执行时间', align='center')
      el-table-column(label='订单类型', align='center')
        template(slot-scope='scope')
            span(v-if="scope.row.biz_type == 'U_SHARE_MEMBER'") 优享会员
            span(v-else-if="scope.row.biz_type == 'MEITUAN_HONGBAO'") 美团红包
            span(v-else-if="scope.row.biz_type == 'EASY_ORDER'") 商品订单
            span(v-else-if="scope.row.biz_type == 'EQUITY_MEMBER'") 权益会员
            span(v-else) 无
      el-table-column(label='支付价格', align='center')
        template(slot-scope='scope') {{ scope.row.period_rule_params.single_amount }}元/{{ scope.row.period_rule_params.period_type | periodLabel }}
      el-table-column(label='渠道', align='center')
        template(slot-scope='scope') {{ getDictName(scope.row.channel_code) }}
      el-table-column(label='订单状态', align='center')
        template(slot-scope='scope')
            span(v-if="scope.row.status == 'NORMAL'") 已签约
            span(v-else-if="scope.row.status == 'TEMP'") 暂存
            span(v-else-if="scope.row.status == 'STOP'") 暂停
      el-table-column(label='操作', align='center')
        template(slot-scope='scope')
            el-popover(placement="left", width="800", trigger="click" @show="queryStatus(scope.row)", size="mini")
                el-card
                    ul
                        li(v-for="key in Object.keys(currentBindStatus)", :key="key") {{key}}: {{currentBindStatus[key]}}
                el-button(slot="reference", type="primary", size="mini") 签约状态
    el-pagination(
        @size-change='handleSizeChange',
        @current-change='handleCurrentChange',
        :current-page='paginationInfo.pageNo',
        :page-sizes='[10, 20, 50, 100]',
        :page-size='paginationInfo.pageSize',
        :total='paginationInfo.total',
        layout='total, sizes, prev, pager, next, jumper'
    )
</template>

<script>
export default {
    components: {},
    data() {
        return {
            dictData: [],
            staticsData: {
                normal: {
                    count: 0
                },
                stop: {
                    count: 0
                },
                bind_paid: {
                    count: 0
                },
                trade_success: {
                    count: 0
                },
                trade_refund: {
                    count: 0
                }
            },
            statusList: [
                {
                    label: '已签约',
                    value: 'NORMAL'
                },
                {
                    label: '暂停',
                    value: 'STOP'
                }
            ],
            accountChannelList: [],
            create_date: [new Date(), new Date()],
            paginationInfo: {
                pageSize: 10,
                total: 0,
                pageNo: 1,
                condition: {
                    search_key: '',
                    create_date: '',
                    bind_status: '',
                    biz_type: '',
                    channel_code: '',
                    phone_no: ''
                }
            },
            tableData: [],
            formData: {
            },
            isPayOrderLoading: false,
            currentShowPayOrders: [],
            currentBindStatus: {}
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryList(1);
        this.getDict();
        this.getKQStatics()
    },
    mounted() {
    },
    methods: {
        getKQStatics() {
            this.$service.OnlineOrderService
                .getKQStatics()
                .then((res) => {
                    if (res.data.code === 0) {
                        this.staticsData = res.data.data
                    }
                })
        },
        getDict() {
          this.$service.CommonService
            .getDict({ dict: 'AdChannelInfos' })
            .then(res => {
                if (res.data.code === 0) {
                    this.dictData = res.data.data.dict_data;
                }
            })
        },
        queryStatus(bind) {
            this.currentBindStatus = {}
            this.$service.OnlineOrderService
                .getKuqiQianBindStatus(bind._id)
                .then((res) => {
                    if (res.data.code === 0) {
                        this.currentBindStatus = res.data.data
                        this.queryList()
                    }
                })
            
        },
        queryList(pageNo) {
          if (this.create_date.length >= 2 && this.create_date[0] && this.create_date[1]) {
            this.paginationInfo.condition.create_date = [this.create_date[0], this.create_date[1]];
          } else {
            this.paginationInfo.condition.create_date = null;
          }
          this.paginationInfo.pageNo = pageNo || this.paginationInfo.pageNo;
          this.getBindOrders()
        },
        handleSizeChange(val) {
          window.console.log(`每页 ${val} 条`);
          this.paginationInfo.pageSize = val;
          this.paginationInfo.pageNo = 1;
          this.getBindOrders();
        },
        handleCurrentChange(val) {
          window.console.log(`当前页: ${val}`);
          this.paginationInfo.pageNo = val;
          this.getBindOrders();
        },
        getDictName(str) {
            let name = "无";
            this.dictData.forEach(item => {
                if (item.dictdata_value == str) {
                    name = item.dictdata_name;
                }
            });
            return name;
        },
        getBindOrders() {
          this.$service.OnlineOrderService
            .getAgreementOrdersKQ(this.paginationInfo)
            .then(res => {
              if (res.data.code === 0) {
                  let dataInfo = res.data.data
                  this.paginationInfo.total = dataInfo.total;
                  this.tableData = dataInfo.binds;
              }
            })
        },
    },
    filters: {
        periodLabel(value) {
            let label = ''
            switch(value) {
                case 'MONTH':
                    label = '月'
                    break;
                case 'DAY':
                    label = '日'
                    break;
            }
            return label
        }
    }
}
</script>
<style lang='less' scoped>
.bindOrders {
    ::v-deep .el-form-item__label {
        font-weight: bold;
    }
}
</style>